exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "html{overflow-y:auto}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-fullscreen-dialog.vue"],"names":[],"mappings":"AACA,KACE,eAAiB,CAClB","file":"vuetify-fullscreen-dialog.vue","sourcesContent":["\nhtml {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-252a61c5","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vuetify-fullscreen-dialog.vue
// module id = 808
// module chunks = 21